import filter from "@/api/filter";
// 对账类型reconciliationType，1首期基础费用，2首期梯度加费，3首年后置费用，4续期基础费用，5继续率奖金
export const config = {
  data() {
      return {
          searchParams:{
            value:'',
          },
          columns: []
      };
  },
  methods: {
    getColumns() {
      let idx = ''
      let columns1= [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: "上游结算状态",
          align: "center",
          key: "settlementStatus",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "供应商",
          align: "center",
          key: "supplier",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'productTypeName',
          minWidth: 300
        },
        
        {
          title: '险种分类',
          align: 'center',
          key: 'themeName',
          minWidth: 120
        },
        {
          title: '长短险标志',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            if (params.row.productType == '1') {
              return <span>长险</span>;
            } else if (params.row.productType == '2') {
              return <span>短险</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '业务类别',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sellType = params.row.sellType&&JSON.parse(params.row.sellType);
            if(sellType){
              if (sellType.includes('1')) {
                return <span>网销产品</span>;
              } else if (sellType.includes('3')) {
                return <span>经代产品</span>;
              } else {
                return <span>-</span>;
              }
            }
          }
        },
        {
          title: "最新状态",
          align: "center",
          key: "policyStatus",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "承保日期",
          align: "center",
          key: "insureTime",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if (params.row.insureTime) {
              const value = filter.filterTime(params.row.insureTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "生效日期",
          align: "center",
          key: "effectTime",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.effectTime) {
              const value = filter.filterTime(params.row.effectTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filter.filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.receiptStatus == '-1') {
              return <span>无需回执</span>;
            } else if (params.row.receiptStatus == '0') {
              return <span>待回执</span>;
            } else if (params.row.receiptStatus == '1') {
              return <span>回执成功</span>;
            } else if (params.row.receiptStatus == '2') {
              return <span>回执失败</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filter.filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.verifyStatus == '0') {
              return <span>等待回访</span>;
            } else if (params.row.verifyStatus == '1') {
              return <span>回访成功</span>;
            } else if (params.row.verifyStatus == '2') {
              return <span>回访失败</span>;
            } else if (params.row.verifyStatus == '3') {
              return <span>无需回访</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{filter.filterTime(hesitateDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeValueDesc',
          minWidth: 120
        },
        {
          title: '交费期',
          align: 'center',
          key: 'payValueDesc',
          minWidth: 120
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            let commissionIndex = params.row.commissionIndex;
            return <span>{commissionIndex ? commissionIndex : '-'}</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          key: 'commissionPeriods',
          minWidth: 100
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if ((commissionType == 1||commissionType == 3)&&params.row.commissionIndex > 1){
              return <span>续期基础费用</span>;
            } else if (commissionType == 1||commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 2||commissionType == 4||commissionType == 11||commissionType == 12) {
              return <span>限时加费活动</span>;
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }else if(commissionType == 13||commissionType == 14){
              return <span>梯度加费</span>;
            }else if(commissionType == 15||commissionType == 16){
              return <span>续年服务津贴</span>;
            }else if(commissionType == 17||commissionType == 18){
              return <span>继续率费用</span>;
            }
          },
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 120,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission : '-'}</span>;
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 150,
          render(h, params) {
            const commissionPrice = params.row.commissionPrice;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 2) {
              msg = '部分退保';
            } else if (deductType == 3) {
              msg = '退现价';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;word-break: keep-all;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{commissionPrice ? commissionPrice : '-'}</span>;
            }
          }
        },
        {
          title: "投保人",
          align: "center",
          key: "holderName",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "出单业务员",
          align: "center",
          key: "salesmanName",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        }
      ]

      let columns2= [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: "上游结算状态",
          align: "center",
          key: "settlementStatus",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "供应商",
          align: "center",
          key: "supplier",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'productTypeName',
          minWidth: 300
        },
        
        {
          title: '险种分类',
          align: 'center',
          key: 'themeName',
          minWidth: 120
        },
        {
          title: '长短险标志',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            if (params.row.productType == '1') {
              return <span>长险</span>;
            } else if (params.row.productType == '2') {
              return <span>短险</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '业务类别',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sellType = params.row.sellType&&JSON.parse(params.row.sellType);
            if(sellType){
              if (sellType.includes('1')) {
                return <span>网销产品</span>;
              } else if (sellType.includes('3')) {
                return <span>经代产品</span>;
              } else {
                return <span>-</span>;
              }
            }
          }
        },
        {
          title: "最新状态",
          align: "center",
          key: "policyStatus",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "承保日期",
          align: "center",
          key: "insureTime",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if (params.row.insureTime) {
              const value = filter.filterTime(params.row.insureTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "生效日期",
          align: "center",
          key: "effectTime",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.effectTime) {
              const value = filter.filterTime(params.row.effectTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filter.filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.receiptStatus == '-1') {
              return <span>无需回执</span>;
            } else if (params.row.receiptStatus == '0') {
              return <span>待回执</span>;
            } else if (params.row.receiptStatus == '1') {
              return <span>回执成功</span>;
            } else if (params.row.receiptStatus == '2') {
              return <span>回执失败</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filter.filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.verifyStatus == '0') {
              return <span>等待回访</span>;
            } else if (params.row.verifyStatus == '1') {
              return <span>回访成功</span>;
            } else if (params.row.verifyStatus == '2') {
              return <span>回访失败</span>;
            } else if (params.row.verifyStatus == '3') {
              return <span>无需回访</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{filter.filterTime(hesitateDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeValueDesc',
          minWidth: 120
        },
        {
          title: '交费期',
          align: 'center',
          key: 'payValueDesc',
          minWidth: 120
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            let commissionIndex = params.row.commissionIndex;
            return <span>{commissionIndex ? commissionIndex : '-'}</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          key: 'commissionPeriods',
          minWidth: 100
        },
        {
          title: "应收保费",
          align: "center",
          key: "receivableFee",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "实收保费",
          align: "center",
          key: "actualFee",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if ((commissionType == 1||commissionType == 3)&&params.row.commissionIndex > 1){
              return <span>续期基础费用</span>;
            } else if (commissionType == 1||commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 2||commissionType == 4||commissionType == 11||commissionType == 12) {
              return <span>限时加费活动</span>;
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }else if(commissionType == 13||commissionType == 14){
              return <span>梯度加费</span>;
            }else if(commissionType == 15||commissionType == 16){
              return <span>续年服务津贴</span>;
            }else if(commissionType == 17||commissionType == 18){
              return <span>继续率费用</span>;
            }
          },
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 120,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 120,
          render(h, params) {
            const commissionPrice = params.row.commissionPrice;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 2) {
              msg = '部分退保';
            } else if (deductType == 3) {
              msg = '退现价';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{commissionPrice ? commissionPrice : '-'}</span>;
            }
          }
        },
        {
          title: "投保人",
          align: "center",
          key: "holderName",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "出单业务员",
          align: "center",
          key: "salesmanName",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        }
      ]
      if (this.searchParams.reconciliationType == 1 || this.searchParams.reconciliationType == 2 || this.searchParams.reconciliationType == 3 || this.searchParams.reconciliationType == 5) {
        this.columns = columns1
      }else if(this.searchParams.reconciliationType == 4){
        this.columns = columns2
      }
    },
  }
};